import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Platform } from '@app/classes/platform.class';
import { AuthService } from '@app/services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class EmployeeGuard {
    constructor(
        private auth: AuthService,
        private router: Router
    ) {}

    canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
        const isSelfView = +next.params.employee === this.auth.employee.id;
        const isAdmin = this.auth.can(Platform.permission.administrate);

        if (isSelfView && !isAdmin) {
            this.router.navigate(['/account/personal']);
            return false;
        }

        return true;
    }
}
